import { ErrorType, VAT_COUNTRY_REGEX_MAP, isElectron } from '@fly/shared';

export const getFirstLetter = (str: string | undefined): string => {
  if (!str) {
    return '';
  }
  return str.charAt(0).toUpperCase();
};

export const basePath = (route: string): string => {
  if (isElectron()) return '';
  const base = import.meta.env.VITE_BASE_URL || '/';
  return `${base}${route}`.replace(/\/+/g, '/');
};

export const formatError = (
  error: Error | string
): { error_message: string; error_type: ErrorType } => {
  const errorMessage = typeof error === 'string' ? error : error.message;
  let errorType: ErrorType = 'unknown';
  if (errorMessage.includes('network') || errorMessage.includes('fetch')) {
    errorType = 'network';
  } else if (
    errorMessage.includes('validation') ||
    errorMessage.includes('invalid')
  ) {
    errorType = 'validation';
  } else if (errorMessage.includes('api') || errorMessage.includes('server')) {
    errorType = 'api';
  }
  return { error_message: errorMessage, error_type: errorType };
};

export const isValidVatIdByCountryName = (
  country: string,
  vatId: string
): boolean => {
  const regexPattern = (VAT_COUNTRY_REGEX_MAP as Record<string, string>)[
    country.toLowerCase()
  ];
  if (!regexPattern) return false;
  return new RegExp(regexPattern).test(vatId);
};

export const gitUserName = (
  username: string
): { name: string; firstLetter: string; fullName: string } => {
  if (!username) {
    return { name: '', firstLetter: '', fullName: '' };
  }
  const name = username.split('/').filter(Boolean).at(-1) || '';
  return {
    name,
    fullName: username,
    firstLetter: getFirstLetter(name),
  };
};

export const generateRandomString = (length = 8): string => {
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};
